import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import Radium from 'radium';
import $ from 'jquery'
import { dragNDropConstants } from '../../Globals/constants';
import { semanticColors } from '../../Globals/styles';
import { greyScaleColors } from '../../Globals/styles';

class WorkplaceDropableSorter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnHeight: 0
    }
  }
  componentDidMount = () => {
    if(this.props.isLast) {
      $( window ).resize(() => {
        this.resizeDroptarget();
      });
      this.resizeDroptarget();
    }
  };
  componentWillUnmount = () => {
    $(window).unbind("resize");
  }; 
  resizeDroptarget = () => {
    let columnHeight = $('.columnContainer').height();
    this.setState({
        columnHeight
    });
  };
  getHeight = ()=> {
    let ocupied = this.props.workplacesLength * 50;
    let rest = this.state.columnHeight - ocupied - 30;
    return {height: rest};
  };

  render() {
    const { connectDropTarget, isOver, index, isLast, canDrop,
    isOnlyDropTarget, draggingWorkplace } = this.props;
    let isOverAndCanDrop = canDrop && isOver;
    return  (
      <div>
        {connectDropTarget(
          <div style={
            [
              styles.dropTarget,
              index === 0 && styles.firstDropTarget,
              isOverAndCanDrop && styles.isOverDropTarget,
              isLast && styles.isLastTarget,
              isLast && this.getHeight(),
              isOnlyDropTarget && styles.isOnlyDropTarget,
              !draggingWorkplace && styles.noWorkplaceDragging
            ]
          }></div>
        )}
        <div style={[styles.dropContainer, isOverAndCanDrop && styles.isOver]}>
        </div>
    </div>)
  }
}


var styles = {
  dropTarget: {
    top: '-20px',
    height: '52px',
    position: 'absolute',
    width: '100%'
  },
  firstDropTarget: {
    top: '-15px',
    left: '0',
    height: '42px'
  },
  isOnlyDropTarget:{
    top: '0',
    height: '100%'
  },
  isOverDropTarget: {
    height: '64px'
  },
  isLastTarget: {
    top: '53px'
  },
  dropContainer: {
    transition: 'height 0.3s',
    height: '0px',
    marginTop: '0px',
    position: 'static',
    overflow: 'hidden'
  },
  isOver: {
    height: '40px',
    marginTop: '12px',
    backgroundColor: greyScaleColors.greyLighter,
    marginBottom: '10px',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderColor: semanticColors.info,
    borderRadius: '2px',
    clear: 'both'
  },
  noWorkplaceDragging: {
    height: '0'
  }
}


const workplaceTarget = {
  drop(props, monitor) {
    if(monitor.didDrop()) return;
    let workplace = monitor.getItem().workplace;
    let position = monitor.getItem().position;
    props.onWorkplaceDrop(workplace.id, props.columnIndex, props.index, position.columnIndex, position.index);
  },
  canDrop(props, monitor) {
    let position = monitor.getItem().position;
    if (props.columnIndex===position.columnIndex){
      if (props.index===position.index+1 || props.index===position.index)
        return false;
    }
    return true
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop()
  };
}
  WorkplaceDropableSorter.propTypes = {
    isOver: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    columnIndex: PropTypes.number.isRequired,
    isLast: PropTypes.bool.isRequired,
    canDrop: PropTypes.bool.isRequired,
    isOnlyDropTarget: PropTypes.bool,
    draggingWorkplace: PropTypes.string,
    onWorkplaceDrop: PropTypes.func.isRequired,
    workplacesLength: PropTypes.number.isRequired
  };
export default DropTarget(dragNDropConstants.WORKPLACE, workplaceTarget, collect)(Radium(WorkplaceDropableSorter));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/workplaceDropableSorter.jsx